"use strict";
var ApiPaymentInformation = (function () {
    function ApiPaymentInformation() {
    }
    return ApiPaymentInformation;
}());
exports.ApiPaymentInformation = ApiPaymentInformation;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-payment-information.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-payment-information.model.js